var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlistIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "none",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.647,3.286a4.048,4.048,0,0,0-2.1-2.076c-3.8-1.471-6.343,2.678-6.343,2.678S7.663-.262,3.865,1.21a4.048,4.048,0,0,0-2.1,2.076C.151,6.494,1.2,10.822,3.891,12.418L10.207,16.9l6.316-4.484c2.695-1.6,3.74-5.923,2.124-9.132",
    transform: "translate(4.928 6.497)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistIconMobile);
export default __webpack_public_path__ + "static/media/wishlist-icon-mobile.dbae506f6fe391d1f6909b2aa0cb9276.svg";
export { ForwardRef as ReactComponent };